var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ver",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_60",
    "data-name": "Rect\\xE1ngulo 60",
    width: 20.392,
    height: 14.267,
    transform: "translate(0 0)",
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22",
    "data-name": "Rect\\xE1ngulo 22",
    width: 24,
    height: 24,
    fill: "#1c1c1c",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_102",
    "data-name": "Grupo 102",
    transform: "translate(2 5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_101",
    "data-name": "Grupo 101",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_41",
    "data-name": "Trazado 41",
    d: "M20.094,5.867A11.049,11.049,0,0,0,10.195,0,11.049,11.049,0,0,0,.3,5.867,2.847,2.847,0,0,0,.3,8.4a11.049,11.049,0,0,0,9.9,5.865,11.048,11.048,0,0,0,9.9-5.867,2.849,2.849,0,0,0,0-2.533M18.752,7.729a9.535,9.535,0,0,1-8.557,5.038A9.534,9.534,0,0,1,1.639,7.729a1.33,1.33,0,0,1,0-1.189A9.535,9.535,0,0,1,10.195,1.5a9.538,9.538,0,0,1,8.557,5.039,1.332,1.332,0,0,1,0,1.19",
    fill: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_42",
    "data-name": "Trazado 42",
    d: "M10.2,2.959A4.174,4.174,0,1,0,14.37,7.134,4.179,4.179,0,0,0,10.2,2.959M13.12,7.134A2.924,2.924,0,1,1,10.2,4.209,2.928,2.928,0,0,1,13.12,7.134",
    fill: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_43",
    "data-name": "Trazado 43",
    d: "M10.2,5.106a2.028,2.028,0,1,0,2.028,2.028A2.028,2.028,0,0,0,10.2,5.106",
    fill: "#1c1c1c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVer);
export default __webpack_public_path__ + "static/media/ver.3fa7a583ff225a70bea40f835939e964.svg";
export { ForwardRef as ReactComponent };